module.exports = __webpack_public_path__ + "static/media/recipieBanner.61599ec8.png";